define([], function() {
  "use strict";
  
  return (function() {
    var sizes = [],
        meta,
        extractedStyles,
        namedQueries;
    
    // https://github.com/zurb/foundation-sites/blob/v6.5.3/js/foundation.util.mediaQuery.js#L204-L238
    var parseStyleToObject = function(str) {
      var styleObject = {};

      if (typeof str !== 'string') {
        return styleObject;
      }

      str = str.trim().slice(1, -1); // browsers re-quote string style values

      if (!str) {
        return styleObject;
      }

      styleObject = str.split('&').reduce(function(ret, param) {
        var parts = param.replace(/\+/g, ' ').split('=');
        var key = parts[0];
        var val = parts[1];
        key = decodeURIComponent(key);

        // missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        val = typeof val === 'undefined' ? null : decodeURIComponent(val);

        if (!ret.hasOwnProperty(key)) {
          ret[key] = val;
        } else if (Array.isArray(ret[key])) {
          ret[key].push(val);
        } else {
          ret[key] = [ret[key], val];
        }
        return ret;
      }, {});

      return styleObject;
    };

    var size = function() {
      var matched;

      for(var i=0; i<sizes.length; i++) {
        var query = sizes[i];

        if(window.matchMedia(query.value).matches) {
          matched = query;
        }
      }

      if(typeof matched === 'object') {
        return matched.name;
      } else {
        return matched;
      }
    };

    // This uses the Foundation 6 way of passing media breakpoint
    // to the JS. It outputs the breakpoint {name=size} as the 
    // font family for the meta.foundation-mq element.
    // See if the meta object is already there or create it
    meta = document.querySelector('meta.foundation-mq');
    if(!meta){
      meta = document.createElement('meta');
      meta.className = 'foundation-mq';
      document.head.appendChild(meta);
    }

    // Get the computed styles for the meta element to extract the
    // breakpoint names and sizes
    // ie. "small=0em&medium=40em&large=64em&xlarge=86.25em"
    extractedStyles = window.getComputedStyle(meta, null).getPropertyValue('font-family');
    namedQueries = parseStyleToObject(extractedStyles);

    for(var key in namedQueries) {
      if(namedQueries.hasOwnProperty(key)) {
        sizes.push({
          name: key,
          value: 'only screen and (min-width: '+namedQueries[key]+')'
        });
      }
    }

    window.main = window.main || {};
    window.main.screen = window.main.screen || {
      size: function() {
        console.error('The global function main.screen.size() is being '+
                      'deprecated and no longer supported. Please update '+
                      'to use shared.main.screen as an imported module.');
        return size();
      }
    };
    // Expose some internal properties and methods
    return {
      size: size,
      sizes: sizes
    };
  })();
});